import React, { useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom'; // Corrected import for useParams
import { updateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { Tooltip } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ExpenseHeadCreate = () => {
    const { id: recordId } = useParams(); // Use useParams to get the record ID from the URL
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [formData, setFormData] = useState({
        BankName: '',
        IFSC: '',
        AccountNo: '',
        Branch: '',
        IsExpenseOrIncome: true,
        OpeningBalance: 0,
        CompanyId: companyId,
    });

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : type === 'radio' ? value === 'true' : value,
        }));
    };

    const submitData = (event) => {
        event.preventDefault();
        setIsLoading(true);

        const CreateData = {
            ...formData,
            UpdatedBy: userId,
            CompanyId: companyId,
        };

        if (!formData.Name) { // Check if the category is selected
            setErrorMessage("Name is required!");
            setIsLoading(false);
            return;
        }


        postData('ExpenseHeadApi', CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/ExpenseHeadIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };



    return (
       
        <div className="w-full max-w-lg container mt-2 mx-auto px-4">
            <form onSubmit={submitData}>
                <div className="w-full mb-2 flex flex-col sm:flex-row items-center justify-between">
                    <h6 className='productHead flex-grow linkcolor text-center md:text-left' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>
                      ACCOUNT HEAD CREATE
                    </h6>
                    <div className="flex mt-2 sm:mt-0">
                        <Tooltip title="Exit">
                            <Link to="/ExpenseHeadIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'brown', fontWeight: 'bolder' }}>
                                    Back To List <ArrowForwardIosIcon />
                                </Button>
                            </Link>
                        </Tooltip>
                        <Tooltip title="SAVE">
                            <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading} className="ml-2">
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>
                        </Tooltip>
                    </div>
                </div>
                {errorMessage && <p className="text-red-500 mb-4">{errorMessage}</p>}
                <div className="w-full mb-4">
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="name">
                        Name
                        <span className="text-red-500">*</span>
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        name="Name"
                        value={formData.Name}
                        onChange={handleChange}
                        type="text"
                        placeholder="Enter name"
                        required
                        maxLength={50}
                    />
                </div>

                <div className="w-full mb-4 flex flex-col sm:flex-row">
                    <div className="w-full sm:w-3/4 mb-4 sm:mb-0 sm:mr-2">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="contactNumber1">
                            Remarks
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="Remarks"
                            value={formData.Remarks}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Remarks"
                            required
                            maxLength={200}
                        />
                    </div>

                    <div className="w-full sm:w-1/5 mb-4 sm:pl-2">
                        <label className="block text-gray-700 text-base font-bold mb-2">
                            Income / Expense
                        </label>
                        <div>
                            <label className="inline-flex items-center">
                                <input
                                    type="radio"
                                    className="form-radio h-4 w-4 text-green-500 border-4 border-gray-400 rounded-full checked:bg-green-500 checked:border-transparent"
                                    name="IsExpenseOrIncome"
                                    value={true}
                                    checked={formData.IsExpenseOrIncome === true}
                                    onChange={handleChange}
                                />
                                <span className="ml-2"> <strong>Income</strong></span>
                            </label>
                            <label className="inline-flex items-center ml-6">
                                <input
                                    type="radio"
                                    className="form-radio h-4 w-4 text-green-500 border-4 border-gray-400 rounded-full checked:bg-green-500 checked:border-transparent"
                                    name="IsExpenseOrIncome"
                                    value={false}
                                    checked={formData.IsExpenseOrIncome === false}
                                    onChange={handleChange}
                                />
                                <span className="ml-2"> <strong>Expense</strong></span>
                            </label>
                        </div>
                    </div>
                </div>
            </form>
        </div>

    );
};

export default ExpenseHeadCreate;
